export enum fileUploadModalActions {
  Upload,
  Cancel,
}
